import { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import { getArrayOfValues, processData } from "../../../../utils/Helper";
// import gradient from "chartjs-plugin-gradient";
// import { redPayNumberFormat } from "@/utils/helper/Helper";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
  // gradient
);

const options = {
  elements: {
    line: {
      tension: 0.4,
      spanGaps: true,
    },
  },
  maintainAspectRatio: false,
  responsive: true,
  datalabels: {
    display: false,
  },
  plugins: {
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
    legend: {
      display: false,
      position: "top",
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      display: true,
      grid: {
        display: false,
      },
      beginAtZero: true,
      ticks: {
        callback: (val: any) =>
          `${RazorNumberFormat(val, {
            hideDecimal: true,
            hideSymbol: true,
            numberAbbreviate: true,
          })}`,
        display: true,
        // stepSize: 1000,
      },
      //   suggestedMin: 0,
      //   suggestedMax: 500000,
    },
  },
};

interface MyComponentProps {
  datatoSHow?: any;
  activeTab?: string;
}

const MultiLineChart = ({ activeTab }: MyComponentProps) => {
  const [datatoSHow, setDataToShow] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        borderColor: "rgba(17, 156, 43, 0.5) ",
        backgroundColor: "#119C2BE5",
        yAxisID: "y",
      },
      {
        label: "",
        data: [],
        borderColor: "rgba(236, 20, 16, 0.5)",
        backgroundColor: "#EC1410CC",
        yAxisID: "y",
      },
      {
        label: "",
        data: [],
        borderColor: "rgba(15, 43, 142, .5)",
        backgroundColor: "#0F2B8E",
        //   yAxisID: "y",
      },
    ],
  });
  const { customer_metric } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    if (Object?.keys(customer_metric)?.length > 0) {
      const val = {
        labels: getArrayOfValues(
          "label",
          customer_metric?.customer_activity,
          false,
          activeTab === "month"
        ),
        datasets: [
          {
            label: "Active Customer",
            data: processData(
              getArrayOfValues(
                "active_customers",
                customer_metric?.customer_activity,
                true
              )
            ),
            borderColor: "rgba(17, 156, 43, 0.5)",
            backgroundColor: "#119C2BE5",
          },
          {
            label: "Inactive Customer",
            data: processData(
              getArrayOfValues(
                "inactive_customers",
                customer_metric?.customer_activity,
                true
              )
            ),
            borderColor: "rgba(236, 20, 16, 0.5)",
            backgroundColor: "#EC1410CC",
            // yAxisID: "y1",
          },
          {
            label: "Signed Up Customer",
            data: processData(
              getArrayOfValues(
                "signed_up_customers",
                customer_metric?.customer_activity,
                true
              )
            ),
            borderColor: "rgba(15, 43, 142, .5)",
            backgroundColor: "#0F2B8E",
          },
        ],
      };

      setDataToShow(val);
    }
  }, [customer_metric]);

  return (
    <>
      <Line
        height={100}
        width={100}
        redraw={true}
        options={options as any}
        data={datatoSHow}
      />
    </>
  );
};

export default MultiLineChart;
